import api from "Services/API";

export const getNotification = () => {
    return api.get("/admin/notification");
};

export const settNotification = (body: { message: string }) => {
    return api.post("/admin/notification", body);
};
